import React, { useEffect } from 'react'
import { useIntl } from 'react-intl'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Box, Typography } from '@mui/material'

import { PageDisplayer } from '../../../../ui'
import { useCombos } from '../../../../features/combos'
import { usePORequests, PORequestsForm } from '../../../../features/po-requests'
import { PO_REQUESTS_COMBOS_IDS } from '../../constants'

export const PORequestsDetailPage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { poRequestId } = useParams()
  useCombos(PO_REQUESTS_COMBOS_IDS)
  const { formatMessage } = useIntl()
  const { detailLoading, detailError, getPORequest } = usePORequests()

  useEffect(() => {
    getPORequest(poRequestId)
  }, [poRequestId]) // eslint-disable-line react-hooks/exhaustive-deps

  const handleGoBack = () => {
    const prevSearch = location.state?.prevSearch || ''
    navigate('/po-requests' + prevSearch)
  }

  return (
    <PageDisplayer
      maxWidth="md"
      loading={detailLoading}
      handleGoBack={handleGoBack}
      textGoBack={formatMessage({ id: 'pages.poRequests.detail.goBack' })}
    >
      {detailError ? (
        formatMessage({ id: 'pages.poRequests.detail.error' })
      ) : (
        <>
          <Box mb={2}>
            <Typography variant="h4" color="textSecondary">
              {formatMessage({ id: 'pages.poRequests.detail.title' })}
            </Typography>
          </Box>
          <Box mb={2}>
            <PORequestsForm />
          </Box>
        </>
      )}
    </PageDisplayer>
  )
}
